<template>
  <Modal :id="'cmp-distribution-perform-modal'" @cancelled="onCancel">
    <template slot="header"> New Statement {{this.$route.query.account_name}} </template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'statement_year'"
          required
          showValidationIcons
          @validated="onValidation"
          v-bind="textFieldConfig"
          v-model="statementData.statement_year"
          isModel
          :placeholder="$t('year')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>

        <Dropdown
          class="dt-dropdown m2"
          :options="periodTV"
          box
          :placeholder="$t('period')"
          v-on:selectedChange="(e) => onDropdownChange('statement_period_txt', e)"
          :listHeight="150"
          :selected="periodTV.find((b) => b.value == statementData.statement_period_txt)"
          showValidationIcons
          required
          immediateValidation
          @validated="(e) => onValidation('statement_period_txt', e)"
        ></Dropdown>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s7" 
        @click.stop="onRunImport" 
        v-if="merlin && merlin!=''"
        :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }"
      >
        {{ $t("Run Import") }}
      </button>
      <button class="dt-button s7" @click.stop="onCancel" style="margin-left: 25px;">
        {{ $t("cancel") }}
      </button>
      <button
        :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s7"
        @click.stop="onOKClick"
      >
          {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { AccountService } from "../../services/account.service";
import { createTV, tv } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
import { distributionStatementListLDTRoutes } from '../../router/routes';
import {
  confirmDelete,
  confirmMessage,
  confirmOK,
  okMessage,
} from "../../../../dt-plugins/confirmation/confirmation-common";
export default {
  components: {
    Modal,
  },
  props: {},
  data: function () {
    return {
  
      statementData:{
        account_id	:this.$route.query.account_id,
        statement_year:'',
        statement_period_txt:null,
        statement_setting_id:	this.$route.query.statement_setting_id
      },

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      validationResult: {},
      merlinConfig:{}

      // Mark: Data
    };
  },
  watch: {},
  mounted:async function () {
    const statement_settings_id = this.$route.query.statement_setting_id;

    const res = await AccountService.amazonDssData(statement_settings_id);

    this.merlinConfig = { ...res.data }

    console.log("{{{{{{{{{{{{SSSSSSS}}}}}}}}}}}}",this.merlinConfig)
  },

  computed: {
    merlin:function(){
      return this.merlinConfig.merlin||''
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    periodTV:function(){
      return[
          {text:'M1',value:'M1'},
          {text:'M2',value:'M2'},
          {text:'M3',value:'M3'},
          {text:'M4',value:'M4'},
          {text:'M5',value:'M5'},
          {text:'M6',value:'M6'},
          {text:'M7',value:'M7'},
          {text:'M8',value:'M8'},
          {text:'M9',value:'M9'},
          {text:'M10',value:'M10'},
          {text:'M11',value:'M11'},
          {text:'M12',value:'M12'},
          {text:'Q1',value:'Q1'},
          {text:'Q2',value:'Q2'},
          {text:'Q3',value:'Q3'},
          {text:'Q4',value:'Q4'},
          {text:'S1',value:'S1'},
          {text:'S2',value:'S2'},
          {text:'Y',value:'Y'},
      ]
    },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },


    onTextFieldValueChange: function (name, value) {
      this.statementData[name] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onOKClick:async  function () {
      console.log(":::::::",this.statementData)

      const resData = await AccountService.addCurSttmnt({...this.statementData});

      console.log(":::::::",resData)

      const { statement_id } =resData.data;

      this.onCancel();
      this.$router.push({
        name: distributionStatementListLDTRoutes.names.tab,
        params: {
          statement_id:statement_id,
          tab: "summary"
        }
      });

      //distributionStatementListLDTRoutes


    },

    onRunImport:async function(){
      const { domain_tld } = window.HttpClient.getBaseURLObject();
      console.log(this.$t,"::::::::::this",domain_tld)
     

      const payload = {
        statement_setting_id:this.$route.query.statement_setting_id,
        statement_year:	this.statementData.statement_year,
        statement_period_txt:	this.statementData.statement_period_txt,
        merlin:	this.merlin
      }
      console.log(payload,"::::::::::this",domain_tld)

      AccountService.merlinAutoImport(payload,domain_tld);

      const confirmationResult = await okMessage(
        this.$t(
          "Your upload is being processed. You will be notified when your process is completed"
        ),
        "NOTICE"
      );
      this.onCancel();

      if (confirmationResult === "ok") {
       
      }
      
    },

    onDropdownChange(name, value) {
      this.statementData[name] = value.value;
    },

  },
};
</script>

<style lang="scss">
.cmp-distribution-perform-modal {
  .checkbox-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
  }
  .dt-checkbox-control {
    display: flex;
    margin: 5px;
    height: 25px;
    padding-right: 10px;
    .dt-checkbox {
      padding-top: 5px;
    }
    .dt-checkbox-label {
      padding-left: 5px;
    }
    .checkmark {
      top: 3px;
    }
  }
}
</style>